<div class="color-bar"></div>

<div class="conteudo">
  <div class="container-fluid cartoes" style="background-color: #fff;">

    <div class="row faixa-conteudo pt0">
      <div class="col col-lg-12">
        <div class="caixa">
          <div class="conteudo-caixa-sem-titulo sem-padding">
            <div class="filtro-dash">
              <div>
                <div class="filtro ng-star-inserted" style="margin: 10px 22px 0px 0px;">
                  Dealers:
                </div>

                <span
                  class="btn btn-outline-info btn-sm"
                  *ngFor="let dealer of filtrosDealers.selecionados()"
                  style="margin: 6px 2px 0px 2px; text-transform: uppercase;"
                  (click)="removerDealer(dealer)">
                  {{ dealer.nome }}
                  <i class="fa fa-times" aria-hidden="true"></i>
                </span>

                <div class="botao">
                  <button class="btn btn-info btn-sm" type="button" (click)="selecionarDealer()">
                    <em class="fa fa-plus"></em>
                  </button>
                </div>

                <div class="clear"></div>
              </div>
            </div>

            <hr>

            <div class="row ptb50">
              <!-- Os campos de data foram removidos: a consulta considera
                   sempre as ordens dos ultimos 90 dias. -->
              <div class="col col-6 d-flex align-items-center">
                <span class="text-muted">
                  <i class="fa fa-info-circle mr-1"></i>
                  Exibindo as ordens de serviço dos últimos 90 dias.
                </span>
              </div>

              <div class="col col-6">
                <button type="button" class="btn btn-primary mt-3 mr-2" (click)="filtroAPI()">
                  Filtrar
                  <i class="fas fa-search"></i>
                </button>

                <button
                  [class.btn-info]="!getListagemComFiltros()"
                  [class.btn-warning]="getListagemComFiltros()"
                  class="btn mt-3"
                  type="button"
                  (click)="exibirFiltro()">
                  Mais filtros
                  <em class="fa fa-filter"></em>
                </button>

                <button
                  pButton
                  class="p-button-outlined p-button-secondary p-button-sm float-right mt-3"
                  type="button"
                  (click)="exportExcel()">
                  <i class="fa fa-download mr-1"></i>
                  Export Excel
                </button>

                <!-- Segunda extracao: alcanca inclusive os chassis que
                     sairam da listagem por estarem fora dos 90 dias. -->
                <button
                  pButton
                  class="p-button-outlined p-button-help p-button-sm float-right mt-3 mr-2"
                  type="button"
                  pTooltip="Exporta todos os veículos que já foram marcados ou que possuem observações, inclusive fora dos 90 dias"
                  tooltipPosition="top"
                  (click)="exportAcompanhamentos()">
                  <i class="fa fa-history mr-1"></i>
                  Export Acompanhamentos
                </button>
              </div>
            </div>

            <hr>

          </div>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-center">
      <div *ngIf="cargaTela == true">
        <div class="w-100 d-flex justify-content-center mt-4">
          <p-progressSpinner></p-progressSpinner>
        </div>

        <div class="w-100 d-flex justify-content-center">
          <label>Loading...</label>
        </div>
      </div>
    </div>

    <div *ngIf="dealersDados?.length <= 0 && cargaTela == false" class="sem-registros text-muted mt-2">
      Nenhum registro para exibir.
    </div>

    <p-table
      #dt
      *ngIf="dealersDados?.length > 0"
      [value]="dealersDados"
      dataKey="numeroChassi"
      selectionMode="single"
      styleClass="p-datatable-responsive-demo p-datatable-striped p-datatable-sm"
      [columns]="selectedColumns"
      [paginator]="dealersDados?.length > 10"
      [rows]="10"
      [loading]="loading"
      [autoLayout]="true"
      [showCurrentPageReport]="true"
      [rowsPerPageOptions]="[10,20,30,50,100]"
      currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registro(s)"
      [globalFilterFields]="[
        'numeroChassi',
        'dealer',
        'numeroOs',
        'tipoOs',
        'nomeCliente',
        'status',
        'dataAbertura',
        'dataLiberacao',
        'dataFechamento'
      ]"
      id="excel-table">

      <ng-template pTemplate="caption">
        <div class="table-header">
          <span class="p-input-icon-left mr-1">
            <i class="pi pi-search"></i>
            <input
              pInputText
              type="text"
              (input)="dt.filterGlobal($event.target.value, 'contains')"
              placeholder="Filtro Geral..." />
          </span>

          <p-multiSelect
            [options]="cols"
            [(ngModel)]="selectedColumns"
            optionLabel="header"
            selectedItemsLabel="{0} colunas selecionadas"
            [style]="{minWidth: '200px'}"
            placeholder="Colunas">
          </p-multiSelect>
        </div>
      </ng-template>

      <ng-template pTemplate="header" let-columns>
        <tr>
          <ng-container *ngFor="let col of columns">
            <th
              class="text-center"
              [pSortableColumn]="col.field"
              style="background-color:black;color:white;">
              {{ col.header }}
              <img class="mb-1" width="10" height="10" src="assets/img/imgIconSort.svg" alt="Sort" />
            </th>
          </ng-container>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-item let-columns="columns">
        <tr>
          <ng-container *ngFor="let col of columns">

            <!-- Chassi: link para o RMPV detalhado -->
            <td *ngIf="col.field === 'numeroChassi'" class="text-center">
              <button
                class="btn-link-chassi"
                type="button"
                (click)="abrirRmpvDetalhado(item.numeroChassi)">
                {{ item.numeroChassi }}
              </button>
            </td>

            <!-- Iniciado: uma vez marcado nao pode ser desmarcado -->
            <td *ngIf="col.field === 'iniciado'" class="text-center">
              <p-checkbox
                [binary]="true"
                [ngModel]="estaIniciado(item)"
                [disabled]="estaIniciado(item)"
                [pTooltip]="tooltipIniciado(item)"
                tooltipPosition="top"
                (onChange)="marcarIniciado(item)">
              </p-checkbox>
            </td>

            <!-- Finalizado: uma vez marcado nao pode ser desmarcado -->
            <td *ngIf="col.field === 'finalizado'" class="text-center">
              <p-checkbox
                [binary]="true"
                [ngModel]="estaFinalizado(item)"
                [disabled]="estaFinalizado(item)"
                [pTooltip]="tooltipFinalizado(item)"
                tooltipPosition="top"
                (onChange)="marcarFinalizado(item)">
              </p-checkbox>
            </td>

            <!-- Observacoes: abre o historico do chassi -->
            <td *ngIf="col.field === 'observacoes'" class="text-center">
              <button
                pButton
                pRipple
                type="button"
                icon="pi pi-file"
                class="p-button-rounded p-button-sm"
                [ngClass]="item.qtdObservacoes > 0 ? 'p-button-info' : 'p-button-secondary p-button-outlined'"
                [pTooltip]="item.qtdObservacoes > 0 ? item.qtdObservacoes + ' observação(ões) registrada(s)' : 'Incluir observação'"
                tooltipPosition="top"
                [label]="item.qtdObservacoes > 0 ? item.qtdObservacoes.toString() : ''"
                (click)="abrirObservacoes(item)">
              </button>
            </td>

            <!-- Demais colunas -->
            <td
              *ngIf="col.field !== 'numeroChassi'
                  && col.field !== 'iniciado'
                  && col.field !== 'finalizado'
                  && col.field !== 'observacoes'"
              class="text-center">
              {{ item[col.field] }}
            </td>

          </ng-container>
        </tr>
      </ng-template>

    </p-table>

  </div>
</div>

<p-dialog
  header="Definir filtros"
  [(visible)]="displayFiltros"
  [style]="{width: '550px'}"
  [modal]="true"
  [draggable]="false">

  <form [formGroup]="form">
    <div class="container striped-rows">

      <div class="row ptb5">
        <div class="col col-4">
          Chassi
        </div>

        <div class="col col-8">
          <input
            class="form-control form-control-sm"
            type="text"
            placeholder="Informe o chassi"
            formControlName="numeroChassi">
        </div>
      </div>

    </div>
  </form>

  <ng-template pTemplate="footer">
    <button type="button" class="btn btn-outline-primary" (click)="limparFiltros()">
      <i class="fa fa-trash" aria-hidden="true"></i>
    </button>

    <button type="button" class="btn btn-info" (click)="filtroAPI()">
      Filtrar
    </button>
  </ng-template>
</p-dialog>

<!-- Historico de acompanhamento do chassi.
     As observacoes apenas se acumulam: nenhuma anterior pode ser
     alterada ou removida. -->
<p-dialog
  header="Acompanhamento do veículo"
  [(visible)]="displayObservacoes"
  [style]="{width: '720px'}"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  (onHide)="fecharObservacoes()">

  <div style="margin-bottom: 12px; font-weight: bold;">
    Chassi: {{ chassiSelecionado }}
  </div>

  <div *ngIf="carregandoHistorico" class="text-center mb-3">
    <p-progressSpinner [style]="{width: '40px', height: '40px'}"></p-progressSpinner>
  </div>

  <div *ngIf="!carregandoHistorico">

    <div *ngIf="historicoAcompanhamento.length === 0" class="text-muted mb-3">
      Nenhum registro de acompanhamento para este veículo.
    </div>

    <div
      *ngIf="historicoAcompanhamento.length > 0"
      style="max-height: 300px; overflow-y: auto; border: 1px solid #dee2e6; border-radius: 4px; margin-bottom: 12px;">

      <table class="table table-sm table-striped mb-0">
        <thead>
          <tr>
            <th style="width: 60px;">Seq.</th>
            <th style="width: 140px;">Data/Hora</th>
            <th style="width: 140px;">Usuário</th>
            <th>Registro</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let evento of historicoAcompanhamento">
            <td>{{ evento.sequencia }}</td>
            <td>{{ evento.dataHora }}</td>
            <td>{{ evento.usuario }}</td>
            <td style="white-space: pre-wrap;">{{ descricaoEvento(evento) }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="form-group">
      <label>Nova observação</label>
      <textarea
        class="form-control form-control-sm"
        rows="4"
        placeholder="Digite a observação..."
        [(ngModel)]="novaObservacao">
      </textarea>
    </div>

    <div class="text-muted" style="font-size: 0.85rem;">
      As observações são apenas incluídas. Registros anteriores não são alterados nem removidos.
    </div>

  </div>

  <ng-template pTemplate="footer">
    <button
      pButton
      type="button"
      label="Fechar"
      class="p-button-outlined p-button-secondary p-button-sm"
      (click)="fecharObservacoes()">
    </button>

    <button
      pButton
      type="button"
      icon="pi pi-check"
      label="Incluir observação"
      class="p-button-sm"
      [disabled]="salvandoObservacao"
      (click)="salvarObservacao()">
    </button>
  </ng-template>
</p-dialog>

<app-filtro-dealers
  [(visible)]="displayFiltrosDealers"
  [dealers]="filtrosDealers.dealers"
  [headerTitle]="'Selecione os Dealers'"
  [filterPlaceholder]="'Filtrar Dealers'"
  (dealerSelected)="onAdicionarDealerFiltro($event)">
</app-filtro-dealers>

<p-toast key="veiculoFrequente" position="bottom-right"></p-toast>